var map = {
	"./svg/cursive/lowercase/a.svg": 161,
	"./svg/cursive/lowercase/b.svg": 162,
	"./svg/cursive/lowercase/c.svg": 163,
	"./svg/cursive/lowercase/d.svg": 164,
	"./svg/cursive/lowercase/e.svg": 165,
	"./svg/cursive/lowercase/f.svg": 166,
	"./svg/cursive/lowercase/g.svg": 167,
	"./svg/cursive/lowercase/h.svg": 168,
	"./svg/cursive/lowercase/i.svg": 169,
	"./svg/cursive/lowercase/j.svg": 170,
	"./svg/cursive/lowercase/k.svg": 171,
	"./svg/cursive/lowercase/l.svg": 172,
	"./svg/cursive/lowercase/m.svg": 173,
	"./svg/cursive/lowercase/n-spanish.svg": 174,
	"./svg/cursive/lowercase/n.svg": 175,
	"./svg/cursive/lowercase/o.svg": 176,
	"./svg/cursive/lowercase/p.svg": 177,
	"./svg/cursive/lowercase/q.svg": 178,
	"./svg/cursive/lowercase/r.svg": 179,
	"./svg/cursive/lowercase/s.svg": 180,
	"./svg/cursive/lowercase/t.svg": 181,
	"./svg/cursive/lowercase/u.svg": 182,
	"./svg/cursive/lowercase/v.svg": 183,
	"./svg/cursive/lowercase/w.svg": 184,
	"./svg/cursive/lowercase/x.svg": 185,
	"./svg/cursive/lowercase/y.svg": 186,
	"./svg/cursive/lowercase/z.svg": 187,
	"./svg/cursive/uppercase/A.svg": 188,
	"./svg/cursive/uppercase/B.svg": 189,
	"./svg/cursive/uppercase/C.svg": 190,
	"./svg/cursive/uppercase/D.svg": 191,
	"./svg/cursive/uppercase/E.svg": 192,
	"./svg/cursive/uppercase/F.svg": 193,
	"./svg/cursive/uppercase/G.svg": 194,
	"./svg/cursive/uppercase/H.svg": 195,
	"./svg/cursive/uppercase/I.svg": 196,
	"./svg/cursive/uppercase/J.svg": 197,
	"./svg/cursive/uppercase/K.svg": 198,
	"./svg/cursive/uppercase/L.svg": 199,
	"./svg/cursive/uppercase/M.svg": 200,
	"./svg/cursive/uppercase/N-spanish.svg": 201,
	"./svg/cursive/uppercase/N.svg": 202,
	"./svg/cursive/uppercase/O.svg": 203,
	"./svg/cursive/uppercase/P.svg": 204,
	"./svg/cursive/uppercase/Q.svg": 205,
	"./svg/cursive/uppercase/R.svg": 206,
	"./svg/cursive/uppercase/S.svg": 207,
	"./svg/cursive/uppercase/T.svg": 208,
	"./svg/cursive/uppercase/U.svg": 209,
	"./svg/cursive/uppercase/V.svg": 210,
	"./svg/cursive/uppercase/W.svg": 211,
	"./svg/cursive/uppercase/X.svg": 212,
	"./svg/cursive/uppercase/Y.svg": 213,
	"./svg/cursive/uppercase/Z.svg": 214,
	"./svg/images/play-button.svg": 88,
	"./svg/number/0.svg": 215,
	"./svg/number/1.svg": 216,
	"./svg/number/2.svg": 217,
	"./svg/number/3.svg": 218,
	"./svg/number/4.svg": 219,
	"./svg/number/5.svg": 220,
	"./svg/number/6.svg": 221,
	"./svg/number/7.svg": 222,
	"./svg/number/8.svg": 223,
	"./svg/number/9.svg": 224,
	"./svg/print/lowercase/a.svg": 225,
	"./svg/print/lowercase/b.svg": 226,
	"./svg/print/lowercase/c.svg": 227,
	"./svg/print/lowercase/d.svg": 228,
	"./svg/print/lowercase/e.svg": 229,
	"./svg/print/lowercase/f.svg": 230,
	"./svg/print/lowercase/g.svg": 231,
	"./svg/print/lowercase/h.svg": 232,
	"./svg/print/lowercase/i.svg": 233,
	"./svg/print/lowercase/j.svg": 234,
	"./svg/print/lowercase/k.svg": 235,
	"./svg/print/lowercase/l.svg": 236,
	"./svg/print/lowercase/m.svg": 237,
	"./svg/print/lowercase/n-spanish.svg": 238,
	"./svg/print/lowercase/n.svg": 239,
	"./svg/print/lowercase/o.svg": 240,
	"./svg/print/lowercase/p.svg": 241,
	"./svg/print/lowercase/q.svg": 242,
	"./svg/print/lowercase/r.svg": 243,
	"./svg/print/lowercase/s.svg": 244,
	"./svg/print/lowercase/t.svg": 245,
	"./svg/print/lowercase/u.svg": 246,
	"./svg/print/lowercase/v.svg": 247,
	"./svg/print/lowercase/w.svg": 248,
	"./svg/print/lowercase/x.svg": 249,
	"./svg/print/lowercase/y.svg": 250,
	"./svg/print/lowercase/z.svg": 251,
	"./svg/print/uppercase/A.svg": 252,
	"./svg/print/uppercase/B.svg": 253,
	"./svg/print/uppercase/C.svg": 254,
	"./svg/print/uppercase/D.svg": 255,
	"./svg/print/uppercase/E.svg": 256,
	"./svg/print/uppercase/F.svg": 257,
	"./svg/print/uppercase/G.svg": 258,
	"./svg/print/uppercase/H.svg": 259,
	"./svg/print/uppercase/I.svg": 260,
	"./svg/print/uppercase/J.svg": 261,
	"./svg/print/uppercase/K.svg": 262,
	"./svg/print/uppercase/L.svg": 263,
	"./svg/print/uppercase/M.svg": 264,
	"./svg/print/uppercase/N-spanish.svg": 265,
	"./svg/print/uppercase/N.svg": 266,
	"./svg/print/uppercase/O.svg": 267,
	"./svg/print/uppercase/P.svg": 268,
	"./svg/print/uppercase/Q.svg": 269,
	"./svg/print/uppercase/R.svg": 270,
	"./svg/print/uppercase/S.svg": 271,
	"./svg/print/uppercase/T.svg": 272,
	"./svg/print/uppercase/U.svg": 273,
	"./svg/print/uppercase/V.svg": 274,
	"./svg/print/uppercase/W.svg": 275,
	"./svg/print/uppercase/X.svg": 276,
	"./svg/print/uppercase/Y.svg": 277,
	"./svg/print/uppercase/Z.svg": 278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 160;